import { render, staticRenderFns } from "./UnauthorizedMessage.vue?vue&type=template&id=bcce2e1a&"
import script from "./UnauthorizedMessage.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcce2e1a')) {
      api.createRecord('bcce2e1a', component.options)
    } else {
      api.reload('bcce2e1a', component.options)
    }
    module.hot.accept("./UnauthorizedMessage.vue?vue&type=template&id=bcce2e1a&", function () {
      api.rerender('bcce2e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnauthorizedMessage.vue"
export default component.exports